<template>
  <Paginator
      empty-info="Вы не комментировали ни одну фотографию в группе"
      :data="comments"
      :endpoint="endpoint"
      @load="onLoad"
  >
    <v-list :dense="$vuetify.breakpoint.mobile">
      <v-list-item
          two-line
          v-for="comment in comments"
          :key="comment.id"
          @click="openComment(comment)" ng-init="photo=$ctrl.comments.photos[comment.photoId]">
        <v-list-item-avatar>
          <v-img
              v-if="photoMap[comment.photoId]"
             :src="photoMap[comment.photoId].preview"
          ></v-img>
          <v-icon
              v-else
          >mdi-comment</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Комментарий от {{comment.date | date}}</v-list-item-title>
          <v-list-item-subtitle>{{comment.text}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon color="pink">mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </Paginator>
</template>

<script>
import Paginator from '@/components/Paginator'
import {getSourceId} from '@/composables/context'
import {enableRefresh, windowOpen} from '@/services/vkApi'

export default {
  name: 'CommentList',
  components: {Paginator},
  beforeDestroy () {
    enableRefresh()
  },
  created () {
    enableRefresh(false)
  },
  data () {
    return {
      comments: [],
      endpoint: `${this.$API.COMMENTS.LIST}?sourceId=${getSourceId()}`,
      photoMap: {}
    }
  },
  methods: {
    onLoad: function (data) {
      this.photoMap = Object.assign({}, this.photoMap, data.photos)
      this.comments = this.comments.concat(data.items)
    },
    openComment: function (comment) {
      windowOpen(comment.url)
    }
  }
}
</script>

<style scoped>

</style>